export const localFormatter = (link: string) : string => {
    const currentUrl = window.location.href;
    let formattedlink = link;
    if (currentUrl.includes('http://localhost')) formattedlink = link.replace('https://stg-swap.trkbit.co','http://localhost:3000')
    return formattedlink;
}

export const textFormatterWalletHiddenChars = (str: string, size: number) : string=> {
    if (!str) return '';
    let encodedWallet = '';
    for (let i=0; i < size; i++) encodedWallet += str[i];
    encodedWallet += '....';
    for (let i=(str.length-size); i < str.length; i++) encodedWallet += str[i];
    return encodedWallet;
}

export const changeClass = (x:any): string => {        
    let css_class = 'text-info';
    if (x.activity === 'done' || x.activity === 'processing') css_class = 'text-warning';
    if (x.activity === 'success' || x.activity === 'done') css_class = 'text-success';
    if (x.activity === 'error') css_class = 'text-danger';
    if (x.activity === 'withdrawal') css_class = 'text-withdrawal';
    if (x.event.status === 'expired') css_class = 'text-expired';
    if (!x.event.updated_at) css_class += ' updating'
    return css_class;
}

export const shortenLargeNames = (name: string) => {

    const limiter = 18;

    if (name.length > limiter) {
        const parts = name.split(' ')
        let returnName = parts[0] + " " + parts[parts.length-1]
        if (returnName.length > limiter) returnName = parts[0];
        if (returnName.length > limiter) returnName = textFormatterWalletHiddenChars(returnName,6);
        return returnName;
    }
    
    return name;
}

export const formattedDateExport = (s : any) => {

    return new Date(s || null).toLocaleString('pt-BR', {
        weekday: 'long',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });

}

export const formatDatePtBr = (s: any): string => { 
    if (!s) return '- - -';

    const date = new Date(s);
    if (isNaN(date.getTime())) return 'Data inválida'; // Handle invalid dates

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
};

export const exchangeRateTransformer = (s:string) : string => {
    if (!s) return '- - -';
    if (s === 'fixed-rate') return "Taxa Fixa";
    if (s === 'float-rate') return "Taxa Flutuante";
    return '';
}

export const purchaseError = (s:string):string => {
    if (!s) return '- - -';
    if (s.includes('min amount')) return "Valor mínimo não alcançado, por favor digite um valor maior.";
    return '';
}